import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi, { ISaveAutoPayOptionRequest } from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createSaveAutoPayOptionThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.SaveAutoPayOption,
    async (body: ISaveAutoPayOptionRequest) => {
      const response = await api.saveAutoPayOption(body);

      return response;
    },
  );
